import { Component, OnInit, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

@Component({
  selector: 'app-digital-documents-add',
  templateUrl: './college-documents-add.component.html',
  styleUrls: ['./college-documents-add.component.scss']
})
export class CollegeDocumentsComponent implements OnInit {

  constructor() { }

  public config1: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null
  };

  public onUploadInit(args: any): void { }

  public onUploadError(args: any): void { }

  public onUploadSuccess(args: any): void { }

  ngOnInit() {
  }

}
